export const valute = [
    {label: "MDL", value: 1},
    {label: "USD", value: 2},
    {label: "EUR", value: 3},
    {label: "RUB", value: 4},
    {label: "UAH", value: 5}
];

export const penalty = [
    {label: "% din suma pe zi", value:false},
    {label: "suma fixă pe zi", value:true},
];

export const interestRates = [
    { label: "0%", value: 0.0 },
    { label: "5%", value: 5 },
    { label: "9%", value: 9 },
    { label: "orice numar", value: "custom" }
];

export const timesPeriod = [
    { label: '180 zile', value: 1 },
    { label: '3 ani', value: 2 },
    { label: "perioada dorita", value: "custom" }
];

export const combinedCalcTypes = [
    { label: 'Penalitate', value: 1 },
    { label: 'Dobanda', value: 2 },
    { label: "Combinat", value: 3 }
];

export const settlementOptions = [
    { label: 'DEBIT', value: 'DEBIT' },
    { label: 'CREDIT', value: 'CREDIT' },
];

export const contractStatuses = [
    { label: 'Toate Statusurile', value: 'Toate Statusurile' },
    { label: 'Activ', value: 'ACTIVE' },
    { label: 'Încheiat', value: 'CONCLUDED' },
    { label: 'Litigiu', value: 'DISPUTE' },
];

export const paysFrequency = [
    { label: 'Lunar', value:'MONTHLY'},
    { label: 'Trimestrial', value:'QUARTERLY'},
    { label: 'Anual', value:'ANNUAL'},
    { label: 'O singură dată', value:'ONCE'},
];

export const currencies = [
    { label: 'MDL', value: 'MDL'},
    { label: 'EUR', value: 'EUR'},
    { label: 'USD', value: 'USD'},
    { label: 'RUB', value: 'RUB'},
    { label: 'UAH', value: 'UAH'},
];

export const debtorStatuses = [
    { label: 'Toți', value: 'Toți' },
    { label: 'Activ', value: 'ACTIVE' },
    { label: 'Inactiv', value: 'INACTIVE' },
    { label: 'Blocat', value: 'BLOCKED' },
];

export const claimTypesOptions = [
    { label: "Notificare de întârziere", value: "DELAY_NOTIFICATION"},
    { label: "Somație de plată", value: "PAYMENT_ORDER"},
    { label: "Notificare inițiere proces", value: "PROCESS_INITIATION_NOTIFICATION"},
];